<template>
    <div>
    <v-dialog v-model="visualizar" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ servicio.nombre }}</span>
          <v-spacer></v-spacer>
         
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="servicio.nombre" label="Nombre" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="servicio.descripcion" label="Descripción" outlined></v-text-field>
              </v-col>
 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import api from "../conf/ruta-base"
import moment from "moment";
import axios from 'axios';
import swal from "sweetalert";
moment.locale('es');
export default {
    data() {
        return {
            servicio:{},
            servicioDefault: {},
        }
    },
  props: {
    editedItem: {
      type: Object,
      default: null
    },
    editedIndex: {
        type: Number,
        default: -1
    },
    visualizar: {
        type: Boolean,
        default: false,
    }
  },
  watch:{
    editedItem(data){
        if(data) this.servicio = data;
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
    close(){
        this.$emit('close',false)
    },
    presave(){
        if(!this.servicio.nombre || !this.servicio.descripcion) {
            swal('','Los campos de identificacion son obligatorios','error'); return;
        }
        if(this.editedIndex == -1){
            axios.post(`${api.api}servicios`,this.servicio).then(res=>{
                this.$emit('cargaServicios',res.data)
                this.$emit('close',false)
                swal('','servicio guardado','success');
            }).catch(err=>{
                swal('','Error al guardar servicio','error');
            })
        }else{
            axios.put(`${api.api}servicios/${this.servicio.id}`,this.servicio).then(res=>{
                this.$emit('cargaServicios',this.servicio)
                //this.$emit('close',false)
                swal('','servicio actualizado','success');
            }).catch(err=>{
                swal('','Error al actualizar servicio','error');
            })
        }
    },
  },
}
</script>